export const MARKET_CAR_LOG_INFO_LIST_REQUEST = 'MARKET_CAR_LOG_INFO_LIST_REQUEST';

export const MARKET_CAR_BOX_LOG_INFO_LIST_REQUEST = 'MARKET_CAR_BOX_LOG_INFO_LIST_REQUEST';

export const MARKET_GEM_LOG_INFO_LIST_REQUEST = 'MARKET_GEM_LOG_INFO_LIST_REQUEST';

export const MARKET_ITEMS_LOG_INFO_LIST_REQUEST = 'MARKET_ITEMS_LOG_INFO_LIST_REQUEST';

export const MARKET_PILOT_LOG_INFO_LIST_REQUEST = 'MARKET_PILOT_LOG_INFO_LIST_REQUEST';